import { ProductType } from '../types';

/**
 * Product types are stored in the database under English keys (wine, spirit,
 * cigar, gift, other) and shown in Polish. The mapping used to be duplicated in
 * ProductFilters, and Dashboard did not use it at all -- it read the optional
 * `product_type` string straight off the product and fell back to "Alkohol"
 * whenever the API had not populated it, so wines were labelled Alkohol on the
 * card grid and Wine in the table.
 */
const DISPLAY_NAMES: Record<string, string> = {
  wine: 'Wino',
  cigar: 'Cygaro',
  other: 'Inne',
  spirit: 'Wysokoprocentowe',
  gift: 'Prezent',
};

/** Genitive forms, for "Szukaj wina..." style placeholders. */
const GENITIVE_NAMES: Record<string, string> = {
  wine: 'wina',
  cigar: 'cygar',
  other: 'innych',
  spirit: 'wysokoprocentowe',
  gift: 'prezentów',
};

/** The raw key, lowercased -- also the CSS modifier class on a type badge. */
export function productTypeKey(
  productTypeId: number | string | undefined,
  productTypes: ProductType[]
): string {
  if (productTypeId === undefined || productTypeId === null || productTypeId === '') return '';
  const match = productTypes.find((type) => type.id.toString() === productTypeId.toString());
  return match?.name?.toLowerCase() ?? '';
}

/** The Polish label shown to a person. */
export function productTypeLabel(
  productTypeId: number | string | undefined,
  productTypes: ProductType[]
): string {
  const key = productTypeKey(productTypeId, productTypes);
  if (!key) return 'Nieznany';
  return DISPLAY_NAMES[key] ?? key;
}

/** The Polish genitive, for search placeholders. Falls back to "produktów". */
export function productTypeGenitive(
  productTypeId: number | string | undefined,
  productTypes: ProductType[]
): string {
  const key = productTypeKey(productTypeId, productTypes);
  if (!key) return 'produktów';
  return GENITIVE_NAMES[key] ?? key;
}
